<template>
  <div class="apply-box" v-show="applyBoxShow">
    <div class="apply-mask"></div>
    <div class="apply-content">
      <i class="iconfont icon-close icon" @click="handleCloseApply"></i>
      <template v-if="applyType == '1'">
        <div class="info">
          <p v-if="info">
            直播观看{{ info.live_study_time | watch_record_format }}，点播观看{{ info.record_study_time | watch_record_format }}
          </p>
          <p v-if="info">预计{{ info.userClassHour }}学时</p>
        </div>
        <p class="tips-a" v-if="notOver">
          该课程最多可获得{{ info.maxClassHour }}学时，还有{{
              info.maxClassHour - info.userClassHour
          }}学时可以获得，要继续学习吗？
        </p>
        <p class="tips-a" v-if="over">恭喜你已学完，立即申请可获得{{ info.maxClassHour }}学时</p>
        <div class="come-study" v-if="notOver" @click="handleCloseApply">继续学习</div>
        <div class="come-study" v-if="over" @click="handleApply(info)">申请学时</div>
      </template>
      <div class="tips-c" v-if="notOver">
          <div class="line"></div>
          <span v-if="applyType == '1'">立即申请可获得 {{ info.userClassHour }} 学时</span>
          <span v-if="applyType == '2'">立即申请可获得 {{ info.maxClassHour }} 学时</span>
          <div class="line"></div>
        </div>
      <div class="now-apply" v-if="notOver" @click="handleApply(info)">立即申请学时</div>
      <div class="tips-e">一个课程只能申请一次学时</div>
    </div>
  </div>
</template>

<script>
import { applyClassHour } from '@/api/dd'
export default {
  name: 'apply-box',
  props: {
    applyBoxShow: {
      type: Boolean,
      required: true
    },
    info: {
      type: Object,
      required: true
    },
    applyType: {
      type: Number
    }
  },
  computed: {
    // 学完状态
    over() {
      return this.info && this.info.userClassHour >= this.info.maxClassHour
    },
    // 没有学完状态
    notOver() {
      return this.info && this.info.userClassHour < this.info.maxClassHour
    }
  },
  methods: {
    handleCloseApply() {
      this.$emit('CloseApply')
    },
    handleApply(info) {
      applyClassHour({
        eventInfoId: info.event_info_id,
        applyClassHour: info.userClassHour
      }).then(res => {
        if (res.code === 0 && res.success) {
          if (res.data && res.data === -4) {
            // 弹窗
            this.$emit('refresh')
          } else {
            this.$emit('applySuccess')
          }
        }
      })
    }
  },
  watch: {
    info(newV) {
      console.log(newV)
    }
  }
}
</script>

<style lang="scss" scoped>
.apply-box {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;

  .apply-mask {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(0, 5, 26, 0.4);
    z-index: 100;
  }

  .apply-content {
    position: absolute;
    left: 10%;
    top: 50%;
    margin-top: -50%;
    width: 80%;
    padding: 36px 30px;
    box-sizing: border-box;
    background-color: #ffffff;
    border-radius: 12px;
    z-index: 101;

    .icon {
      position: absolute;
      right: 12px;
      top: 12px;
    }

    .info {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      padding: 16px 21px;
      background: rgba(#e7e9ef, 0.32);
      border-radius: 8px;
      box-sizing: border-box;
      text-align: center;

      p {
        margin: 2px 0;
        font-size: 13px;
        color: #909399;
      }
    }

    .tips-a {
      margin-top: 20px;
      line-height: 24px;
      font-size: 13px;
      color: #303133;
      letter-spacing: 0.5px;
      text-align: center;
    }

    .come-study {
      margin-top: 20px;
      width: 100%;
      height: 40px;
      background: linear-gradient(270deg, #4465f3, #4a86f6);
      border-radius: 20px;
      text-align: center;
      line-height: 40px;
      color: #fff;
      font-size: 14px;
      box-sizing: border-box;
    }

    .tips-c {
      margin-top: 24px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .line {
        width: 39px;
        height: 1px;
        background: #e7e9ef;
      }
    }

    .now-apply {
      margin-top: 16px;
      width: 100%;
      height: 40px;
      text-align: center;
      line-height: 40px;
      color: #4465f3;
      border-radius: 20px;
      font-size: 14px;
      box-sizing: border-box;
      border: 1px solid #4670f4;
    }

    .tips-e {
      margin-top: 10px;
      color: #fda423;
      font-size: 13px;
      text-align: center;
    }
  }
}
</style>
